<div *ngIf="spinner?.isVisible() | async" class="overlay">
	<div class="overlay">
		<div class="loader" style="margin-top: 18.5%; opacity: 1px;margin-left: 45%;">
			<span ><img src="../../assets/icons/anim-slide-bottom-v2.gif" alt=""  style ="height:45px"></span>
		</div>
	</div>
</div>